// TODO add a component that is like this one but is used to change steps in the wizard
import React from "react";
import { Row } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  createOpportunity,
  createAndPublishOpportunity,
  saveOpportunitySteps,
  GO_TO_PREVIOUS_WIZARD_STEP,
  CREATE_OPPORTUNITY,
  CREATE_AND_PUBLISH_OPPORTUNITY
} from "../../../store/actions/opportunity";
import { isLoading } from "../../../utils/actions";
import ConfirmButton from "../../../components/ConfirmButton/ConfirmButton";

const CreateNewOpportunity = ({
  createOpportunity,
  createAndPublishOpportunity,
  loadingCreate,
  loadingPublish,
  disabled,
  onGoToPrevious,
  goToPreviousConfirmButtonProps,
  createOpportunityConfirmButtonProps,
  createAndPublishOpportunityConfirmButtonProps
}) => {
  const { t } = useTranslation(["opportunity", "form", "global"]);

  return (
    <Row type="flex" justify="space-between" style={{ marginTop: "24px" }}>
      <ConfirmButton
        popProps={{
          ...goToPreviousConfirmButtonProps.popProps,
          onConfirm: () => {
            if (goToPreviousConfirmButtonProps.onConfirm)
              goToPreviousConfirmButtonProps.onConfirm();
            onGoToPrevious();
          }
        }}
        buttonProps={{
          ...createOpportunityConfirmButtonProps.button,
          type: "quaternary",
          size: "lg",
          style: { marginRight: 20 },
          onClick: onGoToPrevious,
          disabled: loadingPublish || loadingCreate || disabled,
          "data-test": "go-to-previous-step-btn"
        }}
      >
        {t("global:back")}
      </ConfirmButton>
      <div>
        <ConfirmButton
          popProps={{
            ...createOpportunityConfirmButtonProps.popProps,
            onConfirm: () => {
              if (createOpportunityConfirmButtonProps.onConfirm)
                createOpportunityConfirmButtonProps.onConfirm();
              createOpportunity();
            }
          }}
          buttonProps={{
            ...createOpportunityConfirmButtonProps.button,
            size: "lg",
            type: "secondary",
            style: { marginRight: 20, width: 160 },
            onClick: createOpportunity,
            disabled: loadingPublish || disabled,
            loading: loadingCreate,
            "data-test": "create-opportunity-btn"
          }}
        >
          {t("opportunity:wizard.publishing.omit")}
        </ConfirmButton>
        <ConfirmButton
          popProps={{
            ...createAndPublishOpportunityConfirmButtonProps.popProps,
            onConfirm: () => {
              if (createAndPublishOpportunityConfirmButtonProps.onConfirm)
                createAndPublishOpportunityConfirmButtonProps.onConfirm();
              createAndPublishOpportunity();
            }
          }}
          buttonProps={{
            ...createAndPublishOpportunityConfirmButtonProps.button,
            size: "lg",
            style: { marginRight: 20 },
            type: "primary",
            onClick: createAndPublishOpportunity,
            disabled: loadingCreate || disabled,
            loading: loadingPublish,
            "data-test": "publish-opportunity-btn"
          }}
        >
          {t("opportunity:wizard.publishing.publish")}
        </ConfirmButton>
      </div>
    </Row>
  );
};

const enhancer = connect(
  state => ({
    loadingCreate: isLoading(CREATE_OPPORTUNITY, state),
    loadingPublish: isLoading(CREATE_AND_PUBLISH_OPPORTUNITY, state)
  }),
  {
    createOpportunity,
    createAndPublishOpportunity,
    saveOpportunitySteps,
    goToPreviousStep: GO_TO_PREVIOUS_WIZARD_STEP.run
  }
);

export default enhancer(CreateNewOpportunity);
